<template>
  <div data-view="invitation-link">
    <component :is="componentName" :has-aside="false">
      <template v-slot:content>
        <v-row class="form-wrapper normal">
          <div class="invitation-link-box">
            <h2>
              {{ $t('invitation_activating_link') }}
            </h2>
            <div>
              <v-progress-circular
                color="secondary"
                indeterminate
                :width="4"
                :size="32"
              />
            </div>
          </div>
        </v-row>
      </template>
    </component>
  </div>
</template>

<script>
  export default {
    computed: {
      isLogged() {
        return this.$store.getters['auth/isLogged'];
      },
      componentName() {
        return this.isLogged ? 'layout-logged-frame' : 'layout-auth-frame';
      },
    },
    created() {
      this.inviteBusinessUser();
    },
    methods: {
      inviteBusinessUser() {
        const query = {
          token: this.$route.params.token,
          isLogged: !!this.isLogged,
        }
        return this.$store
          .dispatch('businessUsers/inviteBusinessUser', query)
          .then(() => {})
          .catch((err) => console.log(err))
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use '../../assets/styles/theme' as *;

  [data-view='invitation-link'] {
    .layout.form-wrapper {
      height: calc(100vh - 250px);
      justify-content: center;
      align-items: center;
    }

    .invitation-link-box {
      height: 100px;
      text-align: center;

      h2 {
        margin-bottom: 30px;
      }

      h4 {
        color: #8f8f8f;
        font-weight: 500;
      }

      a:link {
        text-decoration: none;
      }
    }
  }
</style>
